import { BusAlertIcon } from 'components/Icons/BusAlertIcon'
import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled.div<{ theme: IRoutePlanningEmptyStateTheme }>`
  border-width: 1px;
  border-style: solid;
  border-radius: 16px;
  border-color: ${({ theme }): string => theme.borderColor};
  background-color: ${({ theme }): string => theme.backgroundColor};
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const IconContainer = styled.div`
  display: flex;
`

const StyledBusAlertIcon = styled(BusAlertIcon)`
  fill: ${({ theme }): string => theme.iconColor};
  width: 32px;
  height: 32px;
`

const Description = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #28265d;
  line-height: 160%;
`

const Action = styled.span`
  font-size: 16px;
  font-weight: 500;
  text-decoration: underline;
  line-height: 160%;
  cursor: pointer;
  color: #28265d;
  margin-left: 3px;
`

export interface IRoutePlanningEmptyStateTheme {
  borderColor: string
  backgroundColor: string
  iconColor: string
}

export const neutralTheme: IRoutePlanningEmptyStateTheme = {
  borderColor: '#B0B0B0',
  backgroundColor: '#F8F8F8',
  iconColor: '#B0B0B0'
}

interface IRoutePlanningEmptyStateProps {
  description: ReactNode
  action?: ReactNode
  theme: IRoutePlanningEmptyStateTheme
}

export const RoutePlanningEmptyState = ({
  description,
  action,
  theme
}: IRoutePlanningEmptyStateProps): ReactElement => {
  return (
    <Container theme={theme}>
      <IconContainer>
        <StyledBusAlertIcon theme={theme} />
      </IconContainer>
      <div>
        <Description>{description}</Description>
        {action && <Action>{action}</Action>}
      </div>
    </Container>
  )
}
